import React from 'react';

const RELOAD_FLAG_PREFIX = 'mc_chunk_reload:';

/**
 * Retry a lazy chunk once, then reload once to recover from a stale Vercel
 * asset manifest after a deploy.
 */
export function lazyWithRetry<T extends React.ComponentType<any>>(
    importFn: () => Promise<{ default: T }>,
    chunkName: string
): React.LazyExoticComponent<T> {
    return React.lazy(async () => {
        try {
            const importedModule = await importFn();
            try {
                sessionStorage.removeItem(RELOAD_FLAG_PREFIX + chunkName);
            } catch {
                /* storage disabled */
            }
            return importedModule;
        } catch {
            await new Promise((resolve) => setTimeout(resolve, 1200));
            try {
                return await importFn();
            } catch (retryError) {
                let alreadyReloaded = false;
                try {
                    alreadyReloaded =
                        sessionStorage.getItem(RELOAD_FLAG_PREFIX + chunkName) === '1';
                    if (!alreadyReloaded) {
                        sessionStorage.setItem(RELOAD_FLAG_PREFIX + chunkName, '1');
                    }
                } catch {
                    /* storage disabled */
                }
                if (!alreadyReloaded) {
                    window.location.reload();
                    return new Promise<never>(() => {});
                }
                throw retryError;
            }
        }
    });
}
